class SupernovaNavigation extends window.BAO.CustomElement {
  constructor () {
    super()

    this.bindSectionObserver = this.bindSectionObserver.bind(this)
    this.observeSections = this.observeSections.bind(this)
    this.bindLinks = this.bindLinks.bind(this)

    this.bindSectionObserver()
  }

  setupListeners () {
    super.setupListeners()

    this.els.link.elements.forEach(link => {
      this.listeners.add(link, 'click', this.bindLinks)
    })
  }

  bindSectionObserver () {
    const sections = this.els.link.elements
      .map(link => {
        const section = document.querySelector(link.getAttribute('href'))

        if (!section) {
          console.warn(
            `No section found with id ${link.getAttribute(
              'href'
            )}. Please check the href of your navigation links.`
          )
        }

        return section
      })
      .filter(section => !!section)

    this.observeSections(sections)
  }

  observeSections (sections) {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.7
    }

    const links = this.els.link.elements

    function observerCallback (entries) {
      entries.forEach(entry => {
        links
          .find(link => link.getAttribute('href') === `#${entry.target.id}`)
          .setAttribute('aria-current', entry.isIntersecting)
      })
    }

    const observer = new IntersectionObserver(observerCallback, observerOptions)

    sections.forEach(sec => observer.observe(sec))
  }

  bindLinks (e) {
    e.preventDefault()

    const target = document.querySelector(
      e.target.closest('a').getAttribute('href')
    )

    if (!target) return

    target.scrollIntoView({ behavior: 'smooth' })
  }
}

if (!customElements.get('supernova-navigation')) {
  customElements.define('supernova-navigation', SupernovaNavigation)
}
